import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import Masthead from '../components/masthead/Masthead.jsx'
import LauderHeader from '../components/lauderHeader/lauderHeader.jsx'
import Layout from '../components/layout'
import background from '../images/landing-bg.png'

const backgroundImage = {
	backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(${background}) `,
}

function specialCharacters(text) {
	//to take care of the curly quotation marks
	if (text) {
		text = JSON.stringify(text)
		let u201D = /\\u201D/i
		let u201C = /\\u201C/i
		text = text.replace(u201D, '\u201D')
		text = text.replace(u201C, '\u201C')
		text = text.replace(/\\/g, '')

		return {
			__html: text,
		}
	}
}
const IndexPage = () => (
	<Layout>
		<div className="intro-background" style={backgroundImage}>
			<LauderHeader></LauderHeader>
			<Masthead
				showTitle={true}
				showModeViewer={false}
				showCatalog={false}
				transparent={true}
			/>
			<section className="intro">
				<StaticQuery
					query={graphql`
						query {
							importJson {
								introduction {
									heading
									subHeading
									copy
									credits
								}
							}
						}
					`}
					render={data => (
						<React.Fragment>
							<div className="intro__row intro__row--headings">
								<h1 className="intro__heading">
										{data.importJson.introduction[0].heading}
								</h1>
								<h2 className="intro__sub-heading">
									{data.importJson.introduction[0].subHeading}
								</h2>
								<div className="intro__copy">
									{data.importJson.introduction[0].copy}
								</div>
							</div>
							<div className="intro__row">
								<Link className="intro-btn" to="documents/">
									<span>View</span>
								</Link>
							</div>
							<div className="intro__row intro__row--collab">
								<div
									className="intro__credits"
									dangerouslySetInnerHTML={{__html: data.importJson.introduction[0].credits}}
								/>
							</div>
						</React.Fragment>
					)}
				/>
			</section>
		</div>
	</Layout>
)

export default IndexPage
